import React from "react";
import PropTypes from "prop-types";
import { handleEnterSpaceKey } from "utils";
import classNames from "classnames";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/SpectrumQuestionRow.scss';

const SpectrumQuestionRow = ({ rowId, row, columns, onOptionSelected, isDisabled }) => {
  const { text: rowText, options } = row;
  const textId = `${rowId}-text`;

  const handleOnChange = (changedOption) => {
    if (isDisabled) {
      return;
    }
    return onOptionSelected(changedOption, row);
  };

  const handleOnKeyUp = (event, changedOption) => {
    if (isDisabled) {
      return;
    }
    return handleEnterSpaceKey(event, () => onOptionSelected(changedOption, row));
  };

  const getExtraLabelClass = (value) => {
    const stepVal = 20;
    const nearestValClass = `csw-q-val-${isNaN(value) ? "NaN" : Math.ceil(Math.abs(value) / stepVal) * stepVal}`;
    const signPre = "csw-q-sign";
    let signClass = null;

    if (isNaN(value)) {
      signClass = `${signPre}-NaN`;
    } else if (value === 0) {
      signClass = `${signPre}-none`;
    } else if (value > 0) {
      signClass = `${signPre}-plus`;
    } else if (value < 0) {
      signClass = `${signPre}-minus`;
    }

    return `${signClass} ${nearestValClass}`;
  };

  return (
    <div className="csw-q-spect-row" id={rowId}>
      <div className="csw-q-spect-row-heading" role="heading" aria-level="2" id={textId}>
        {rowText}
      </div>
      <ul className="csw-q-spect-o-list csw-option-list" role="radiogroup" aria-labelledby={textId}>
        {columns &&
          columns.map((column, index) => {
            const optionDetail = options[index];
            const { id, selected } = optionDetail;
            const { text, value } = column;

            const spectOptId = `csw-q-spect-o-${rowId}-${id}`;
            const spectKey = `${spectOptId}-${index}`;

            return (
              <li className="csw-q-spect-o" key={spectKey} aria-labelledby={`${spectOptId}-lbl`}>
                <input
                  className="csw-q-spect-rdo-input sr-only outline-trigger"
                  type="radio"
                  id={spectOptId}
                  name={rowId}
                  value={text}
                  defaultChecked={selected}
                  onChange={() => handleOnChange(optionDetail)}
                  onKeyUp={(event) => handleOnKeyUp(event, optionDetail)}
                  disabled={isDisabled}
                  tabIndex="-1"
                />
                <label
                  className={classNames("csw-q-spect-lbl outline", getExtraLabelClass(value))}
                  htmlFor={spectOptId}
                  id={`${spectOptId}-lbl`}
                  onKeyUp={(event) => handleOnKeyUp(event, optionDetail)}
                  tabIndex="0"
                  aria-label={`${text} ${rowText}`}
                  aria-describedby={textId}
                  role="radio"
                  aria-checked={selected}
                  aria-disabled={isDisabled}
                >
                  <span className="csw-q-spect-chk csw-option-check-border" aria-hidden="true">
                    {" "}
                  </span>
                  <span className="csw-q-spect-txt">{text}</span>
                </label>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

SpectrumQuestionRow.propTypes /* remove-proptypes */ = {
  rowId: PropTypes.string,
  row: PropTypes.object,
  columns: PropTypes.array,
  onOptionSelected: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default SpectrumQuestionRow;
